import {getDate} from '../../../../../../@casino/lib/getDate';

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'login', label: 'Логин'},
    { id: 'registration', label: 'Дата регистрации'},
    { id: 'sum_win', label: 'Сумма выигрышей'},
    { id: 'sum_bet', label: 'Сумма ставок'},
    { id: 'result', label: 'Сумма проигрыша'}
];

const getRows = (data) => {
    
    return data.map((item) => {
        return {
            id: item.id,
            login: item.login,
            registration: getDate(+item.registration),
            sum_win: new Intl.NumberFormat('ru-RU').format(item.sum_win ? item.sum_win.toFixed(2) : 0) + ' ₽',
            sum_bet: new Intl.NumberFormat('ru-RU').format(item.sum_bet ? item.sum_bet.toFixed(2) : 0) + ' ₽',
            result: new Intl.NumberFormat('ru-RU').format(item.sum_bet - item.sum_win) + ' ₽',
        }
    })
} 

export {
    columns,
    getRows
}